let workerPromise = null;

const DOCUMENT_KEYWORDS = [
  "REPUBLICA DE COLOMBIA",
  "CEDULA",
  "CIUDADANIA",
  "EXTRANJERIA",
  "PASAPORTE",
  "TARJETA DE IDENTIDAD",
];

const getWorker = () => {
  if (!workerPromise) {
    workerPromise = (async () => {
      const { createWorker } = await import("tesseract.js");
      return createWorker("spa");
    })().catch((err) => {
      workerPromise = null;
      throw err;
    });
  }
  return workerPromise;
};

const normalize = (text) =>
  text.toUpperCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

export async function checkDocumentPhoto(file, documentNumber) {
  const worker = await getWorker();
  const { data } = await worker.recognize(file);
  const text = normalize(data.text || "");

  if (!DOCUMENT_KEYWORDS.some((k) => text.includes(k)))
    return {
      ok: false,
      message: "No pudimos reconocer una cédula o documento legal en la foto. Asegúrate de que el documento esté completo, enfocado y con buena luz.",
    };

  const number = String(documentNumber).replace(/\D/g, "");
  const compact = text.replace(/[.,\s]/g, "");
  if (number.length < 6 || !compact.includes(number))
    return {
      ok: false,
      message: "El número de documento que escribiste no aparece en la foto. Revisa el número o vuelve a tomar la foto.",
    };

  return { ok: true };
}
